import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages, FormattedNumber, FormattedRelative } from 'react-intl'
import $ from 'jquery'
import Icon from "../common/icon/icon.component.jsx";
import LoadingSpinner from '../common/spinner/loading.component.jsx';
import ActionButton from '../common/button/actionbutton.component.jsx';

class LoyaltyQuote extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            contactId: this.props.contactId,
            endPoint: this.getEndPoint(this.props),
            pointsBalance: 0,
            discounts: 0,
            loading: true,
        }

        this.onClose = this.props.onClose
        this.closeModals = this.closeModals.bind(this)
    }

    getEndPoint(props) {
        if (props.mainObject) {
            return '/' + props.mainObject + '/' + props.objectId + '/loyalty-discounts'
        }
        return props.invoiceId ? '/invoices/' + props.invoiceId + '/loyalty-discounts' : '/quotes/' + props.quoteId + '/loyalty-discounts'
    }

    componentDidMount() {
        $('#loyaltyModal').modal('show')
        AppContext.getApiClient().get('/contacts/' + this.state.contactId + '/loyalty-customers').then(c => {
            this.setState({
                loading: false,
                pointsBalance: c.attributes.pointsBalance,
                discounts: c.attributes.availableDiscounts.filter(d => parseFloat(d.attributes.discountValue) > 0),
            })
        })
    }

    closeModals(event) {
        $('#loyaltyModal').modal('hide')
        this.onClose()
    }

    redeem(discountId) {
        return function (e) {
            e.preventDefault()
            AppContext.getApiClient().post(this.state.endPoint, {
                discountId: discountId
            }).then(c => {
                this.closeModals(e)
            })
        }.bind(this)
    }

    render() {
        return (
            <div>
                {/************** Discount quote Modal ***************/}
                <div className="modal fade"
                    id="loyaltyModal"
                    role="dialog"
                    aria-labelledby="Loyalty"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="setDiscountModalLabel">
                                    <FormattedMessage
                                        id="invoice.loyalty_modal.title"
                                        defaultMessage="Redeem an offer"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                {this.state.loading ? <div className="container-fluid">
                                    <LoadingSpinner />
                                </div> : <div className="container-fluid">
                                        <div className={'row'}>
                                            <div className={'col-12 py-2'}>
                                                <h1 className={'text-center custom-lead display-4 custom-lead text-custom-secondary'}>
                                                    <FormattedMessage
                                                        id="invoice.loyalty_modal.points_balance"
                                                        defaultMessage="{count} points"
                                                        values={{
                                                            count: <FormattedNumber
                                                                value={this.state.pointsBalance}
                                                            />
                                                        }}
                                                    />
                                                </h1>
                                            </div>
                                        </div>
                                        <div className={'row border-top mt-2 pt-2'}>
                                            {this.state.discounts.length > 0 ? <div className={'col-12'}>
                                                {this.state.discounts.map(d => {
                                                    return <div key={d.id} className={'w-100 d-flex align-items-center border-bottom mb-2 py-2'}>
                                                        <div className={'mr-5'} style={{ width: '200px' }}>
                                                            {d.attributes.image ? <img src={d.attributes.image} className={'w-100'} /> : <h1 className={'py-2 display-4 text-center'}>
                                                                <Icon value={'gift'} />
                                                            </h1>}
                                                        </div>
                                                        <div className={'mr-2 py-2 flex-grow-1'}>
                                                            <h4 className={'mb-1'}>{d.attributes.name}</h4>
                                                            {d.attributes.points > 0 ? <p className={'mb-1'}>
                                                                <FormattedMessage
                                                                    id="invoice.loyalty_modal.cost_points"
                                                                    defaultMessage="For {count} points"
                                                                    values={{
                                                                        count: <kbd><FormattedNumber
                                                                            value={d.attributes.points}
                                                                        /></kbd>
                                                                    }}
                                                                />
                                                            </p> : ''}
                                                            <p className={'mb-0'}>
                                                                {d.attributes.expiresAt ? <FormattedMessage
                                                                    id="invoice.loyalty_modal.expires_in"
                                                                    defaultMessage="Expires {date}"
                                                                    values={{
                                                                        date: <FormattedRelative value={new Date(d.attributes.expiresAt)} />
                                                                    }}
                                                                /> : <FormattedMessage
                                                                        id="invoice.loyalty_modal.never_expires"
                                                                        defaultMessage="Never expires"
                                                                    />}
                                                            </p>
                                                        </div>
                                                        <div className={'mr-2 py-2'}>
                                                            <h3 className={'mb-0'}>
                                                                <span className={'badge badge-pill badge-secondary'} style={this.state.style}>
                                                                    <Icon value={'gift'} className={'mr-2'} />
                                                                    {d.attributes.discountType === 'currency-value' ? <FormattedNumber
                                                                        currency={AppContext.getAccount().attributes.currency}
                                                                        style={'currency'}
                                                                        value={'-' + d.attributes.discountValue}
                                                                    /> : <FormattedNumber
                                                                            style={'percent'}
                                                                            value={-1 * parseFloat(d.attributes.discountValue) / 100}
                                                                        />}
                                                                </span>
                                                            </h3>
                                                        </div>
                                                        <div className={'mr-2 py-2 align-self-center'}>
                                                            <ActionButton className="btn custom-btn-secondary ml-2" onClick={this.redeem(d.id)}>
                                                                <Icon value={"receipt"} className={'mr-2'} />
                                                                <FormattedMessage
                                                                    id="invoice.loyalty_modal.redeem_btn"
                                                                    defaultMessage="Redeem"
                                                                />
                                                            </ActionButton>
                                                        </div>
                                                    </div>
                                                })}
                                            </div> : <div className={'col-12'}>
                                                    <p className={'text-center'}>
                                                        <FormattedMessage
                                                            id="invoice.loyalty_modal.no_offer"
                                                            defaultMessage="No offer available"
                                                        />
                                                    </p>
                                                </div>}
                                        </div>
                                    </div>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="quote.set_discount_modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(LoyaltyQuote)





// WEBPACK FOOTER //
// ./src/quote/loyalty.component.jsx